/**
 * How tall a description box should be: one row per line typed, capped.
 *
 * Description and offer remark are multiline (Akhil, 2026-09-15) — size, spec and packing on
 * their own lines. The box follows the text so nothing is hidden, and stops at six rows so a
 * pasted datasheet scrolls inside the box rather than stretching the row across the screen.
 */
export const MAX_TEXTAREA_ROWS = 6

export function textareaRows(text: string): number {
  const lines = text === '' ? 1 : text.split('\n').length
  return Math.min(MAX_TEXTAREA_ROWS, Math.max(1, lines))
}
